import { createSelector } from 'reselect';

export const getRobotOnlineStatus = createSelector(
  [agentList => agentList, (agentList, robotOnlineStatus) => robotOnlineStatus],
  (agentList, robotOnlineStatus) => {
    return agentList.map(val => {
      const { privilege, id } = val;
      if (privilege === 'bot') {
        return {
          ...val,
          is_online: robotOnlineStatus[id] !== undefined ? robotOnlineStatus[id] : false,
          status: robotOnlineStatus[id] === true ? 'on_duty' : 'off_duty'
        };
      }
      return val;
    });
  }
);

export const getMarketingRobotOnlineStatus = createSelector(
  [agentList => agentList, (agentList, robotOnlineStatus) => robotOnlineStatus],
  (agentList, robotOnlineStatus) => {
    return agentList.map(val => {
      const { privilege, id } = val;
      if (privilege === 'bot:mpush') {
        return {
          ...val,
          is_online: robotOnlineStatus[id] !== undefined ? robotOnlineStatus[id] : false,
          status: robotOnlineStatus[id] === true ? 'on_duty' : 'off_duty'
        };
      }
      return val;
    });
  }
);
